module.exports = __webpack_public_path__ + "img/limpieza.8fd75f50.svg";